/** @format */
import { useMemo } from 'react';

import { Facet } from '@toucan/common/services/search/types';

import { useSearchParams } from '@toucan/client/features/search/components/model-search-results/hooks/use-search-params';

import { useTranslateFilters } from '../use-translate-filters';
import {
    getFacetAllowList,
    getFacetsWithAtLeastTwoValues,
    transformFacetsToFilters,
} from './helpers/facets-to-filters';
import { useTranslatedFacetTitles } from './hooks/use-translated-facet-titles';

export const useFacetsToFilters = (
    facets: Facet[] | undefined,
    outOfStock: boolean,
    openedFilter: Facet | null
) => {
    const searchParams = useSearchParams();
    const { selectedFilters } = searchParams;

    const translatedFacetTitles = useTranslatedFacetTitles();

    const filters = useMemo(() => {
        if (!facets) return [];

        const facetAllowList: string[] = getFacetAllowList(
            selectedFilters,
            outOfStock
        );

        const filteredFacets = getFacetsWithAtLeastTwoValues(
            facets,
            facetAllowList
        );

        const first10Facets = filteredFacets.slice(0, 10);

        return transformFacetsToFilters(
            first10Facets,
            translatedFacetTitles,
            openedFilter
        );
    }, [facets, selectedFilters, outOfStock, openedFilter]);

    return useTranslateFilters(filters);
};
